import React, { forwardRef, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';

import { handleCreation } from '../Register/controller';

const Transition = forwardRef(function Transition(props, ref) {
  return (
    <>
      <Slide direction="up" ref={ref} {...props} />
    </>
  );
});

export default function ConfirmBelowPrice(props) {
  const [open, setOpen] = useState(true);
  const handleUpdate = async () => {
    await handleCreation(
      props.data,
      props.minimumFreightTableItem,
      props.setData,
      props.setErrors,
      props.showSnackbar,
      props.setLoading,
      props.setShowModal,
    );
    setOpen(false);
    props.setBelowMinimumFreightTablePrice(false);
  };

  const handleUpdateCharge = async () => {
    await props.saveData();
    setOpen(false);
    props.setBelowMinimumFreightTablePrice(false);
  };

  const handleUpdateTaxes = async () => {
    await props.saveData();
    setOpen(false);
    props.setBelowMinimumFreightTablePrice(false);
  };

  const handleClose = () => {
    props.setBelowMinimumFreightTablePrice(false);
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}>
        <DialogTitle>Valor abaixo da Tabela ANTT!</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Os valores de {props.belowPriceItems} informados estão abaixo da tabela do frete mínimo!
            Você deseja salvar a rota assim mesmo?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Não</Button>
          <Button
            onClick={
              props.charge ? handleUpdateCharge : props.taxes ? handleUpdateTaxes : handleUpdate
            }
          >
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
